// extracted by mini-css-extract-plugin
export default {"listPage":"List_list-page__tn5Cg","actionBar":"List_action-bar__R-dR-","actionCol":"List_action-col__0VQY6"};